import { createSlice } from '@reduxjs/toolkit';

import { fetchAllPrivateScenario } from './asyncActions';
import { PrivateScenarioState } from './types';

const initialState: PrivateScenarioState = {
  allPrivateScenario: [],
  isLoadingAllPrivateScenario: false
};

const privateScenarioSlice = createSlice({
  name: 'privateScenario',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchAllPrivateScenario.pending, state => {
      state.isLoadingAllPrivateScenario = true;
    });
    builder.addCase(fetchAllPrivateScenario.fulfilled, (state, action) => {
      state.isLoadingAllPrivateScenario = false;
      state.allPrivateScenario = action.payload;
    });
    builder.addCase(fetchAllPrivateScenario.rejected, state => {
      state.isLoadingAllPrivateScenario = false;
    });
  }
});

export default privateScenarioSlice.reducer;
